import BitesApi from '..';

export const getUserOrganization = (user_organization_id: number) =>
  BitesApi.get(`user_organization/${user_organization_id}/`);
